import { createReducer, on } from "@ngrx/store"
import { carouselState } from "../homepage.state"
import * as homePageAction from '../action/fetch_carousel_image.action';

const initialState: carouselState = {
    imageList: null,
    loading: false,
    success: false,
    error: false,
    activeIndex: 0
}

export const carouselReducer = createReducer(
    initialState,
    on(homePageAction.fetchCarouselImagesAction, (state) => ({
        ...state,
        loading: true,
        success: false,
        error: false
    })),
    on(homePageAction.fetchCarouselImagesActionFail, (state, { payload }) => ({
        ...state,
        payload: payload,
        loading: false,
        success: false,
        error: true
    })),
    on(homePageAction.fetchCarouselImagesActionSuccess, (state, { imageList }) => ({
        ...state,
        imageList: imageList,
        loading: false,
        success: true,
        error: false
    })),
    on(homePageAction.updateCarouselImages, (state, { activeIndex }) => ({
        ...state,
        activeIndex: activeIndex
    }))
)